///////////////////////////////////////////////
//      Match Unit component styling         //
///////////////////////////////////////////////

@import './pk-match-unit.variables';

:host {
  @apply flex justify-center;
}

.pk-match-unit {
  @apply relative box-border flex w-full flex-col justify-center [-webkit-font-smoothing:antialiased];

  &.size--xl,
  &.size--m {
    @apply grid grid-cols-[100%] grid-rows-[minmax(26px,auto)_minmax(32px,auto)_minmax(26px,auto)] gap-y-xs2 rounded-[--match-unit--border-radius] bg-[color:--match-unit--background-color] px-xs2 py-xs;

    box-shadow: var(--match-unit--shadow);

    .pk-match__top,
    .pk-match__bottom {
      @apply flex w-full flex-col items-center justify-center;
    }
  }

  &.size--xl {
    @apply sm:grid-rows-[minmax(24px,auto)_minmax(36px,auto)_minmax(24px,auto)] sm:p-xs;
  }

  &.size--l,
  &.size--s,
  &.size--s-plus,
  &.size--l-plus {
    @apply flex-col justify-between bg-[color:--match-unit--background-color];
  }

  &.size--l {
    @apply h-[145px] w-[330px] rounded-s border-0 border-t-[length:--pk-spacing-xs3] border-solid border-t-[color:--match-unit--border-top-color] px-l py-m;
  }

  &.size--s {
    @apply h-[96px] w-[160px] px-s py-xs;

    &::after {
      @apply absolute bottom-s left-auto right-0 top-s w-[1px] bg-[color:--match-unit--border-right-color] content-[''];
    }
  }

  &.size--s-plus,
  &.size--l-plus {
    @apply h-[106px] max-w-[100%] justify-center rounded-l border border-solid border-[color:--match-unit--border-right-color] px-m py-s;
  }

  &.size--s-plus {
    @apply xs:w-[343px];
  }

  &.size--l-plus {
    @apply h-[144px] w-[450px] p-l;
  }
}

@import './pk-match-unit.vertical';

/**
 * Match INFO
 */

@import '../components/match-info/match-info';

/**
 * Match RELATED
 */

@import '../components/match-related/match-related';

/**
 * Match FOULS
 */

@import '../components/match-fouls/match-fouls';

/**
 * Match BASE
 */

.pk-match__base {
  @apply flex grow-[1] basis-full items-center justify-center;
}

/**
 * Match BASE -- TEAMS
 */

@import '../components/match-team/match-team';

/**
 * Match - TEAM RED CARDS
 */

@import '../components/match-team-red-cards/match-team-red-cards';

/**
 * Match BASE -- DATE
 */

@import '../components/match-date/match-date';

/**
 * Match BASE -- SCORE
 */

@import '../components/match-score/match-score';

/**
 * Match POST - PENALTIES SCORE
 */

@import '../components/match-post-penalties-score/match-post-penalties-score';

/**
 * Match STATUS
 */

.pk-match__status {
  @apply relative hidden grow-[1] basis-full flex-row flex-wrap text-center;

  &:not(:empty) {
    @apply flex;
  }
}

/**
 * Math STATUS -- INFO
 */

@import '../components/match-status/match-status';

/**
 * Match LIVE - PENALTIES
 */

@import '../components/match-live-penalties/match-live-penalties';

/**
 * Match CTA PLUS
 */

@import '../components/match-cta/match-cta';

.pk-match__cta-slot {
  @apply mt-xs2 flex justify-center;

  &.is-empty {
    @apply hidden;
  }

  ::slotted(*) {
    @apply font-regular text-s leading-m;
  }

  &:not(.size--s-plus):not(.size--l-plus) {
    ::slotted(*) {
      @apply text-xs;
    }
  }

  &.size--l,
  &.size--s,
  &.size--s-plus,
  &.size--l-plus {
    @apply m-0 min-h-[18px] items-center p-0;
  }

  &.size--s {
    @apply min-h-[16px];
  }

  &.size--s-plus,
  &.size--l-plus {
    &:hover {
      @apply underline;
      text-decoration-color: #1e4fd0;
    }
  }

  &.size--s-plus {
    ::slotted(*) {
      @apply font-semibold;
    }
  }

  &.size--l-plus {
    ::slotted(*) {
      @apply leading-l;
    }
  }
}

.pk-match__highlight-cta {
  @apply flex aspect-[16/9] w-full justify-center overflow-hidden rounded-m;

  &.is-empty {
    @apply hidden;
  }

  ::slotted(*) {
    @apply h-full w-full object-cover;
  }
}

.hidden {
  @include hidden;
}
